import { datadogRum } from '@datadog/browser-rum'

const environment = import.meta.env.VITE_VERCEL_ENV ?? 'development'

export const initializeDatadogRUM = () => {
  datadogRum.init({
    applicationId: 'b730baee-e2d4-4882-bf80-2141e2bffe27',
    clientToken: 'pubf8ff5a5142b011b643d6d66d6053430d',
    site: 'us3.datadoghq.com',
    service: 'attorney-share-marketplace',
    env: environment,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    version: import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend: event => {
      if (
        event.type === 'error' &&
        (event.error?.message?.includes('CanceledError') ||
          event.error?.message?.includes('canceled'))
      ) {
        return false
      }
      return true
    },
  })
}

interface RumUserIdentity {
  id: string
  email?: string
  name?: string
  orgId?: string
}

// Tracks the currently-identified user so re-renders/refetches don't spam
// identical setUser calls, and so clearRumUser is a no-op when nobody was
// identified this page life (ENG-1634).
let identifiedUserId: string | null = null

export const identifyRumUser = ({
  id,
  email,
  name,
  orgId,
}: RumUserIdentity) => {
  if (!id || id === identifiedUserId) return
  identifiedUserId = id
  datadogRum.setUser({
    id,
    email,
    name,
    org_id: orgId,
  })
}

export const clearRumUser = () => {
  if (identifiedUserId === null) return
  identifiedUserId = null
  datadogRum.clearUser()
}
